<template>
  <div class="modal animated fadeIn" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="closeModal()">
          <i class="icon icon-close"></i>
        </span>
        <p class="modal-card-title">{{ $t('proposal_send_modal.send_proposal') }}</p>
      </header>
      <section class="modal-card-body" style="overflow: unset;">

        <div class="control is-horizontal">
          <div class="control-label">
            <label class="label">{{ $t('proposal_send_modal.from') }}</label>
          </div>
          <div class="control">
            {{ spark.state.user.name }} &lt;{{ spark.state.user.email }}&gt;
          </div>
        </div>

        <div class="control is-horizontal">
          <div class="control-label">
            <label class="label">{{ $t('proposal_send_modal.to') }}</label>
          </div>
          <div class="control">
            <div class="select is-fullwidth">
              <multiselect
                v-model="payload.contacts"
                :options="contacts"
                :placeholder="$t('proposal_send_modal.to_placeholder')"
                track-by="id"
                label="name"
                :searchable="true"
                :showLabels="false"
                :multiple="true"
              ></multiselect>
            </div>
          </div>
        </div>

        <div class="control is-horizontal">
          <div class="control-label">
            <label class="label">{{ $t('proposal_send_modal.subject_input.label') }}</label>
          </div>
          <div class="control">
            <input class="input" name="subject" v-model="form.subject" v-validate="'required'" type="text" :placeholder="$t('proposal_send_modal.subject_input.placeholder')" :disabled="sending">
          </div>
        </div>

        <div class="control is-horizontal">
          <div class="control-label">
          </div>
          <div class="control">
            <span class="help-block" v-show="errors.has('subject')">{{ errors.first('subject') }}</span>
          </div>
        </div>

        <!-- <div class="control is-horizontal">
          <div class="control-label">
            <label class="label">Message (optional)</label>
          </div>
          <div class="control">
            <multiselect v-model="selectedSavedMessage" :options="savedMessages" placeholder="Select saved message"
              track-by="id" label="subject" :showLabels="false"></multiselect>
          </div>
        </div> -->

        <!-- <div class="control is-horizontal">
          <div class="control-label">
          </div>
          <div class="control">
            <a @click="Events.$emit('modalOpen', 'savedMessagesModal', { showForm: true })"><span>&#x0002B;</span> New Saved Message</a>
          </div>
        </div> -->

      </section>

      <hr>
      <div class="control message-area">
        <textarea name="body" :placeholder="$t('proposal_send_modal.message_input.placeholder')" v-model="form.body" :disabled="sending"></textarea>
      </div>
      <hr>

      <footer class="modal-card-foot">
        <a class="button is-primary is-large pull-left" @click="send" :disabled="sending">{{ $t('proposal_send_modal.send') }} <loading-indicator v-if="sending" color="#ffffff"></loading-indicator></a>
        <a class="button is-primary is-large is-outlined pull-left" @click="closeModal" :disabled="sending">{{ $t('proposal_send_modal.cancel') }}</a>
      </footer>
    </div>
  </div>
</template>

<script>
  import API from 'mixins/api';

  export default {
    mixins: [API],
    props: ['isActive', 'payload'],
    data() {
      return {
        Events: window.Events,
        sending: false,
        contacts: [],
        savedMessages: [],
        selectedSavedMessage: null,
        form: {
          subject: null,
          body: null,
        }
      }
    },
    beforeMount() {
      this.refreshSavedMessages();

      this.Events.$on('createSavedMessage', (message) => {
        this.selectedSavedMessage = message;
        this.Events.$emit("modalClose", "savedMessagesModal");
        this.refreshSavedMessages();
      });
      this.Events.$on('updateSavedMessage', this.refreshSavedMessages);
      this.Events.$on('deleteSavedMessage', this.refreshSavedMessages);

      this.api().fetchTeamContacts()
        .then(contacts => this.contacts = contacts);
    },
    destroyed() {
      this.Events.$off('createSavedMessage', this.refreshSavedMessages);
      this.Events.$off('updateSavedMessage', this.refreshSavedMessages);
      this.Events.$off('deleteSavedMessage', this.refreshSavedMessages);
    },
    methods: {
      closeModal() {
        this.Events.$emit('closeDocumentSendModal');
        this.form.subject = null;
        this.form.body = null;
      },
      refreshSavedMessages() {
        this.api().fetchSavedMessages()
          .then(savedMessages => this.savedMessages = savedMessages);
      },
      send() {
        if (!this.form.subject) {
          this.errors.add('subject', 'The subject field is required.', 'required');
        }

        if (this.payload.contacts.length < 1) {
          this.errors.add('contacts', 'There must be at least one contact indicated.', 'required');
        }

        if (this.form.subject && this.payload.contacts.length >= 1) {
          this.sending = true;
          return this.api().sendDocument(this.$route.params.id, this.form)
            .then(response => {
                (new Notyf()).confirm(this.$t('proposal_send_modal.proposal_sent'));
                this.$router.push('/a/documents');
                this.sending = false;
              },
              error => {
                (new Notyf()).alert(this.$t('proposal_send_modal.proposal_sent_error'));
                this.sending = false;
              });
        }

      },
    },
    watch: {
      selectedSavedMessage() {
        this.form.subject = this.selectedSavedMessage ? this.selectedSavedMessage.subject : null;
        this.form.body = this.selectedSavedMessage ? this.selectedSavedMessage.body : null;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";
  .fadeIn {
    animation-duration: 500ms;
  }
  .fadeInUp {
    animation-duration: 500ms;
  }

  .control {
    .control-label {
      padding-top: 0;
      display: flex;
      justify-content: center;
      flex-direction: column;
      min-width: 66px;
      .label {
        color: $mutedblue;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-size: 10px;
      }
    }
  }

  .message-area {
    margin-bottom: 0;
    textarea {
      width: 88%;
      outline: none;
      border: 0;
      margin: 0 40px;
      min-height: 140px;
      padding-bottom: 0;
    }
  }

  .saved-messages {
    width: 88%;
    margin: 0 40px;
  }

  input {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid lighten($mutedblue, 12%);
    box-shadow: none;
    &:hover,
    &:active,
    &:focus {
      border-color: lighten($mutedblue, 12%);
    }
  }

  .select:after {
    border: none;
  }

  .modal .modal-card .modal-card-body .control.is-horizontal > .control {
    flex-grow: 9;
  }

  .button {
    .loading {
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// document-send-modal.vue?9dc7d680